var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 4,
  fill: "#1DA1F2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.66 24c6.793 0 10.508-5.387 10.508-10.058 0-.153 0-.305-.01-.457A7.343 7.343 0 0 0 26 11.655a7.632 7.632 0 0 1-2.121.556 3.58 3.58 0 0 0 1.623-1.955 7.603 7.603 0 0 1-2.345.858 3.75 3.75 0 0 0-2.095-1.068 3.84 3.84 0 0 0-2.341.373 3.606 3.606 0 0 0-1.623 1.658 3.4 3.4 0 0 0-.234 2.261 10.854 10.854 0 0 1-4.216-1.072 10.412 10.412 0 0 1-3.395-2.621 3.407 3.407 0 0 0-.405 2.576 3.541 3.541 0 0 0 1.548 2.143 3.791 3.791 0 0 1-1.676-.443v.045c0 .816.295 1.607.835 2.239a3.726 3.726 0 0 0 2.128 1.226 3.846 3.846 0 0 1-1.668.061 3.548 3.548 0 0 0 1.314 1.757c.619.44 1.366.684 2.136.698a7.623 7.623 0 0 1-4.586 1.516c-.294 0-.587-.018-.879-.05a10.798 10.798 0 0 0 5.66 1.584",
  fill: "#fff"
})));
export { SvgTwitter as ReactComponent };